var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedSwitch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4062_1129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00014 11.5H24.3573",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7857 7L7 11.5L12.7857 16",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.357 20.5H6.99986",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5714 25L24.3571 20.5L18.5714 16",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4062_1129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedSwitch);
export default __webpack_public_path__ + "static/media/redSwitch.9c8dba74a0cb7c4e8bf4005fa9f3b82c.svg";
export { ForwardRef as ReactComponent };